import { TimeOut } from '~/services/apis/timeout'

export default defineNuxtRouteMiddleware(async (to, from) => {
	if (to.path !== from.path && import.meta.client) {
		await TimeOut(100)
		/* For the dashboard layout, we are using the h-screen overflow-hidden classes on the dashboard layout,
        and thus, the window is always in view so the scroll on the window element wouldn't appear to scroll.
        Hence, the need to scroll the container with the overflow auto to imitate a scrollToTop.
        */
		document.getElementById('dashboardEl')?.scroll({ top: 0, left: 0, behavior: 'smooth' })
		window.scroll({ behavior: 'smooth', left: 0, top: 0 })
	}
})
